import auth from '@/router/auth'
import CategoryItemIndex from '@/components/domains/Index'

export default [
  {
    path: '/domains',
    name: 'domains-index',
    component: CategoryItemIndex,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/domains/router.js